const DEFAULT_COLOR_SCHEMES = [
  'ws-light-0',
  'ws-light-1',
  'ws-dark-0',
  'ws-dark-1',
  'ws-primary-0',
  'ws-secondary-0',
];

export const PALETTE_PRESET_COLOR_ORDER = [
  'ws-light-0',
  'ws-light-1',
  'ws-secondary-0',
  'ws-primary-0',
  'ws-dark-1',
  'ws-dark-0',
];

export const CUSTOM_PALETTE_PREVIEW_COLOR_ORDER = [
  'ws-light-0',
  'ws-dark-1',
  'ws-primary-0',
  'ws-light-1',
  'ws-dark-0',
  'ws-secondary-0',
];

export const BASE_COLOR_TO_SURFACE_ID = {
  altLight: 'ws-light-0',
  light: 'ws-light-1',
  dark: 'ws-dark-0',
  altDark: 'ws-dark-1',
  primary: 'ws-primary-0',
  secondary: 'ws-secondary-0',
};

export const FALLBACK_COLOR_SCHEME = 'ws-light-0';

export const DEFAULT_SCHEME_PREFIX_MAP = {
  'ws-light-0': 'ws_surface_light_0',
  'ws-light-1': 'ws_surface_light_1',
  'ws-dark-0': 'ws_surface_dark_0',
  'ws-dark-1': 'ws_surface_dark_1',
  'ws-primary-0': 'ws_surface_primary_0',
  'ws-secondary-0': 'ws_surface_secondary_0',
};

// Canonical regex for custom scheme IDs.  Format: ws-custom-{colorType}-{id}
// where colorType is any lowercase letter sequence and id is one or more
// lowercase alphanumeric characters.
export const CUSTOM_SCHEME_ID_RE = /^ws-custom-([a-z]+)-([a-z0-9]+)$/;
// Matches default built-in scheme IDs: ws-{colorType}-{digit}
export const DEFAULT_SCHEME_ID_RE = /^ws-([a-z]+)-\d+$/;

export const CUSTOM_PALETTE_ID_PREFIX = 'custom-palette-';

export default DEFAULT_COLOR_SCHEMES;
